import React from "react";
import images from "../../../Utils/importImages";

function GeneralDetails({ generalDetail , setEditGeneralProfile}) {
  
  let getTitle = () => {
    if (generalDetail?.gender == "Male") {
      return "Mr";
    } else if (generalDetail?.gender == "Female") {
      return "Mrs";
    } else if (generalDetail?.gender == "Other") {
      return "Mr";
    }
    return "Mr";
  };

  let getDateFormatted = (date) => {
    if (!date) return ""; // Handle cases where date is undefined or null

    let [year, month, day] = date.split("-"); // Assuming format is "DD-MM-YYYY"

    // Convert month number to month name
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let monthName = monthNames[parseInt(month, 10) - 1]; // Convert month to index

    return `${day} / ${monthName} / ${year}`;
  };

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>General Details</h3>
        <div className="editable-profile-action">
          Edit <img src={images["edit-profile-details.svg"]} alt="" onClick={() => setEditGeneralProfile(true)}/>
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li>
          <label for="">Name</label>
          <div className="myprofile-general-value">
            {generalDetail?.title} {generalDetail?.first_name} {generalDetail?.last_name}
          </div>
        </li>
        <li>
          <label for="">Birthday</label>
          <div className="myprofile-general-value">
            {generalDetail?.dob == null ? (
              <span>Not Provided</span>
            ) : (
              getDateFormatted(generalDetail?.dob)
            )}
          </div>
        </li>
        <li>
          <label for="">Gender</label>
          <div className="myprofile-general-value">
            {generalDetail?.gender == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.gender
            )}
          </div>
        </li>
        <li>
          <label for="">Address</label>
          <div className="myprofile-general-value">
            {generalDetail?.address == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.address
            )}
          </div>
        </li>
        <li>
          <label for="">Pin Code</label>
          <div className="myprofile-general-value">
            {generalDetail?.pincode == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.pincode
            )}
          </div>
        </li>
        <li>
          <label for="">Country</label>
          <div className="myprofile-general-value country">
            {generalDetail?.country_id == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.country.name
            )}
          </div>
        </li>
        <li>
          <label for="">State</label>
          <div className="myprofile-general-value">
            {generalDetail?.state_id == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.state.name
            )}
          </div>
        </li>
      </ul>
    </div>
  );
}

export default GeneralDetails;
